import React from 'react';
import { Global } from '@emotion/react';
import { useAnimationToggle } from '../../Contexts/AnimationContext';
import { Alert, AlertTitle, AlertDescription, Box, CloseButton } from '@chakra-ui/react';
import { AdminAlertIcon, CloseIcon } from './AdminIcon';

// Keep Chakra toast layout and dismissal behavior, with admin Lucide glyphs.
export default function AdminToast({ status = 'info', variant = 'solid', id, title, description, isClosable, onClose, animationsEnabled: preferredAnimations }) {
  const context = useAnimationToggle();
  const animationsEnabled = preferredAnimations ?? context?.animationsEnabled ?? true;
  const solidBackground = { success: 'green.700', error: 'red.700', warning: 'orange.800', info: 'blue.700' }[status] || 'blue.700';
  const titleId = id === undefined ? undefined : `toast-${id}-title`;
  return (
    <>
    <Global styles={{
      ...(!animationsEnabled ? { '.chakra-toast': { transform: 'none !important', opacity: '1 !important' } } : {}),
      '@media (prefers-reduced-motion: reduce)': { '.chakra-toast': { transform: 'none !important', opacity: '1 !important' } },
    }} />
    <Alert role={status === 'error' ? 'alert' : 'status'} status={status} variant={variant} id={id} alignItems="start" borderRadius="md"
      bg={variant === 'solid' ? solidBackground : undefined} color={variant === 'solid' ? 'white' : undefined}
      boxShadow="lg" paddingEnd={10} textAlign="start" width="auto" aria-labelledby={titleId}>
      <AdminAlertIcon status={status} />
      <Box flex="1" maxWidth="100%">
        {title && <AlertTitle id={titleId}>{title}</AlertTitle>}
        {description && <AlertDescription display="block">{description}</AlertDescription>}
      </Box>
      {isClosable && (
        <CloseButton aria-label="Dismiss notification" minW="32px" minH="32px" size="sm" onClick={onClose} position="absolute" insetEnd={1} top="50%" transform="translateY(-50%)">
          <CloseIcon boxSize={4} />
        </CloseButton>
      )}
    </Alert>
    </>
  );
}
